import * as React from 'react';
import cx from 'classnames';
import ClickAwayListener from 'react-click-away-listener';

import { NewTableColumnAction, NewTableColumnId, NewTableHeaderAction, NewTableRowAction } from '@common/components/new-table/new-table.types';

import './actions.styles.scss';

type Action = NewTableColumnAction | NewTableHeaderAction | NewTableRowAction;

export type ActionsProps = {
  className?: string;
	columnId: NewTableColumnId;
  items: Array<Action>;
  style?: React.CSSProperties;
  onClose: () => void;
};

export const Actions: React.FC<ActionsProps> = (props) => {
	const { className, items = [], style, onClose, columnId } = props;

	const handleClick = React.useCallback((onClick: NewTableColumnAction['onClick']) => (e: React.MouseEvent<HTMLButtonElement>) => {
		if (onClick) {
			onClick({ columnId });
		}
		onClose();
	}, [columnId, onClose]);

	return (
		<ClickAwayListener onClickAway={onClose}>
			<div
				style={style}
				className={cx('NewTableActions', className)}
			>
				{items.map((item) => (
					<button 
						className={cx('NewTableActions__item', (item as NewTableColumnAction | NewTableHeaderAction).className)} 
						key={item.label} 
						onClick={handleClick(item.onClick)}
					>
						{item.label}
					</button>
				))}
			</div>
		</ClickAwayListener>
	);
}